import React from 'react'

import {
  classnames,
  Radio,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import translatePlansRestructure from '../../../Utils/translatePlansRestructure'

function OneTimeOption({
  selected,
  onSelect: handleSelect,
  onNavigate: handleNavigate = NOOP,
  price = null,
  originalPrice = null,
  hasDiscount = false,
  plansRestructureEnabled = false,
}) {
  const restructureClass = (base) => classnames(base, plansRestructureEnabled && `${base}--restructure`)
  const optionClass = classnames(
    restructureClass('subscription-purchase__option'),
    'subscription-purchase__option--onetime',
    selected && 'subscription-purchase__option--selected'
  )

  return (
    <div
      className={optionClass}
      onClick={handleSelect}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          handleSelect()
          return
        }

        handleNavigate(e)
      }}
      role="radio"
      aria-checked={selected}
      tabIndex={selected ? 0 : -1}
    >
      <div className="subscription-purchase__option-radio" aria-hidden="true">
        <Radio
          name="purchaseOption"
          isChecked={selected}
          onChange={handleSelect}
          className="subscription-purchase__radio"
        />
      </div>

      <div className={restructureClass('subscription-purchase__option-content')}>
        <div className={restructureClass('subscription-purchase__option-header')}>
          <span className="subscription-purchase__option-title">
            {plansRestructureEnabled ? translatePlansRestructure('onetime.title') : 'One-time purchase'}
          </span>
          <div className={restructureClass('subscription-purchase__option-price')}>
            {hasDiscount && (
              <span className="subscription-purchase__original-price">{originalPrice}</span>
            )}
            <span className="subscription-purchase__current-price">{price}</span>
          </div>
        </div>
      </div>
    </div>
  )
}

OneTimeOption.propTypes = {
  selected: bool.isRequired,
  onSelect: func.isRequired,
  onNavigate: func,
  price: string,
  originalPrice: string,
  hasDiscount: bool,
  plansRestructureEnabled: bool,
}

export default OneTimeOption
